import React from 'react';
import { Outlet } from 'react-router-dom';
import loginBackground from '../../../assets/login_background.png';
import styles from './LoginLayout.module.css';
import { currentUiVersion } from '@/v2/lib/uiVersion';

/**
 * LoginLayout: Used for login/authentication screens.
 * Displays content over a background image with dark overlay.
 */
const LoginLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  /* The v2 auth screens are full-bleed and bring their own canvas
     — a photo banner on a white surface. Layering them over this
     layout's background image and dark overlay would show through
     and fight the design, so v2 gets the bare outlet. */
  if (currentUiVersion() === 'v2') {
    return <>{children ?? <Outlet />}</>;
  }

  return (
    <div
      className={styles.loginContainer}
      style={{
        '--login-bg-image': `url(${loginBackground})`,
      } as React.CSSProperties}
    >
      {/* Dark overlay */}
      <div className={styles.overlay} />

      {/* Content */}
      <main className={styles.content}>
        {children ? children : <Outlet />}
      </main>
    </div>
  );
};

export default LoginLayout;
